import React from 'react';
import IturriForm from './components/IturriForm';

function App() {
  return (
    <div className="App">
      <IturriForm />
    </div>
  );
}

export default App;